import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course02 from "../../../course/course-02/course";
import course04 from "../../../course/course-04/course";
import lesson0217 from "../../course-02/lesson-17/lesson";
import lesson0415 from "../../course-04/lesson-15/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "e84f0870-fc3a-4003-b205-bd57f4007553",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0217),
    lesson: lesson0217,
  },
  {
    id: "34bd4d09-1751-408d-8cf2-fe57f39690e5",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0415),
    lesson: lesson0415,
  },
];

export default lessonLinks;
